import { GoogleMap, StreetViewPanorama } from '@react-google-maps/api';
import React from 'react';
import classes from './PostMapThumbnail.module.css';
import IconMapMarker from 'components/Maps/IconMapMarker/IconMapMarker';

const postMapThumbnail = (props) => {
  let postLocationMap = null;
  let locationName = null;

  const mapContainerStyle = {
    height: '85px',
    width: '70px',
  };

  const streetViewPanoramaOptions = {
    zoomControl: false,
    controlSize: false,
    clickToGo: false,
    addressControl: false,
    mapTypeControl: false,
    scaleControl: false,
    panControl: false,
    disableDefaultUI: false,
    streetViewControl: false,
    rotateControl: false,
    scrollwheel: false,
    fullscreenControl: false,
    enableCloseIcon: false,
    enableCloseButton: false,
  };
  if (props.post !== null) {
    const geoLocation = props.post.Lat
      ? { lat: parseFloat(props.post.Lat), lng: parseFloat(props.post.Lng) }
      : { lat: parseFloat(props.post.MapLat), lng: parseFloat(props.post.MapLng) };
    postLocationMap = (
      <GoogleMap
        id="marker-example"
        mapTypeId={props.post.MapType ? props.post.MapType : 'roadmap'}
        mapContainerStyle={mapContainerStyle}
        zoom={props.MapType === 'streetview' ? 7 : parseInt(props.post.Zoom, 10)}
        center={geoLocation}
        defaultCenter={geoLocation}
        options={{
          mapTypeId: props.post.MapType ? props.post.MapType : 'roadmap',
          fullscreenControl: false,
          streetViewControl: false,
          mapTypeControl: false,
          minZoom: 3,
        }}
      >
        {props.post.MapType === 'streetview' ? (
          <StreetViewPanorama
            position={geoLocation}
            pov={{
              pitch: parseFloat(props.post.Pitch),
              heading: props.post.Heading ? parseFloat(props.post.Heading) : null,
            }}
            options={streetViewPanoramaOptions}
            visible
          >
            {' '}
          </StreetViewPanorama>
        ) : (
          <IconMapMarker markerColor={props.markerColor} locationIcon={props.locationIcon} geoLocation={geoLocation} />
        )}
      </GoogleMap>
    );
    locationName =
      (props.post.Location && props.post.Location.length > 0 && props.post.Location2 && props.post.Location2.length > 0) ||
      ((!props.post.Location || props.post.Location.length === 0) && (!props.post.Location2 || props.post.Location2.length === 0))
        ? `${props.post.Location}\n${props.post.Location2}`
        : props.post.Location
        ? props.post.Location.replace(', ', '\n')
        : props.post.Location2;
  }
  return (
    <div className={classes.PostMapContainer} onClick={props.clicked}>
      <div className={classes.MapThumb}>{postLocationMap}</div>
      <p className={classes.LocationName}>{locationName}</p>
    </div>
  );
};

export default postMapThumbnail;
